(() => {
  'use strict';
  // The film: the file (720p, or 1080p on wide screens) is chosen by the inline script next to the
  // element before loading starts, and is never swapped while playing. Autoplay can still be refused (iOS Low Power Mode, Safari set to never autoplay,
  // "Auto-Play Video Previews" off), so the first touch or click anywhere starts it.
  const film = document.getElementById('film');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (film && !reduced.matches) {
    film.muted = true;
    film.playsInline = true;
    const play = () => { if (film.paused) film.play().catch(() => {}); };
    play();
    film.addEventListener('canplay', play, { once: true });
    film.addEventListener('loadeddata', play, { once: true });
    document.addEventListener('touchend', play, { once: true, passive: true });
    document.addEventListener('click', play, { once: true });
    document.addEventListener('visibilitychange', () => { if (!document.hidden) play(); });
  } else if (film) {
    film.removeAttribute('autoplay');
  }

  // "Enter with password" unfolds the password field; "Privacy" opens the small sheet.
  const toggle = document.getElementById('password-toggle');
  const panel = document.getElementById('password-panel');
  if (toggle && panel) {
    toggle.addEventListener('click', () => {
      const open = panel.hidden;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) panel.querySelector('input')?.focus();
    });
  }
  const sheet = document.getElementById('privacy-dialog');
  if (sheet) {
    document.querySelectorAll('[data-privacy]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); sheet.showModal(); }));
    sheet.querySelector('[data-close-privacy]')?.addEventListener('click', () => sheet.close());
    sheet.addEventListener('click', event => { if (event.target === sheet) sheet.close(); });
  }

  // The countdown. The drop time is written in Oslo time ("2026-10-23 12:00"); converting it to an
  // instant through Intl means the count is the same for someone in Oslo, London or New York.
  const count = document.querySelector('[data-countdown]');
  if (!count) return;
  const kicker = document.querySelector('[data-kicker]');
  const fields = {
    days: count.querySelector('[data-days]'), hours: count.querySelector('[data-hours]'),
    minutes: count.querySelector('[data-minutes]'), seconds: count.querySelector('[data-seconds]')
  };
  const match = (count.dataset.countdown || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})/);
  if (!match) { count.hidden = true; return; }
  const [y, mo, d, h, mi] = match.slice(1).map(Number);

  function osloOffset(instant) {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Oslo', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date(instant));
    const get = type => Number(parts.find(part => part.type === type).value);
    return Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second')) - Math.floor(instant / 1000) * 1000;
  }
  const naive = Date.UTC(y, mo - 1, d, h, mi);
  let target = naive - osloOffset(naive);
  target = naive - osloOffset(target);   // a second pass settles a date right at a DST change

  // The drop written out under the count, in Oslo time: "Fri 23 Oct · 12:00".
  const when = document.querySelector('[data-when]');
  if (when) {
    const date = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Oslo', weekday: 'short', day: 'numeric', month: 'short' }).format(new Date(target));
    const time = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Oslo', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(target));
    when.textContent = `${date} · ${time} Oslo`;
    when.hidden = false;
  }

  const two = n => String(n).padStart(2, '0');
  let live = false;
  function tick() {
    const left = Math.max(0, target - Date.now());
    const seconds = Math.floor(left / 1000);
    fields.days.textContent = two(Math.floor(seconds / 86400));
    fields.hours.textContent = two(Math.floor(seconds / 3600) % 24);
    fields.minutes.textContent = two(Math.floor(seconds / 60) % 60);
    fields.seconds.textContent = two(seconds % 60);
    if (left === 0 && !live) {
      live = true;
      document.body.classList.add('is-live');
      if (kicker && kicker.dataset.liveText) kicker.textContent = kicker.dataset.liveText;
    }
  }
  tick();
  setInterval(tick, 1000);
})();
